import API from "./api";

export class FechaDesdeService {

    public getFechaDesde = async () => {
        const res = API.get('/negocio/incio-vigencia-minima');
        return res.then(async (resp) => {
            return resp;
        })
        .catch(err => {
            return err
        })
    };

}
